module.exports = __webpack_public_path__ + "static/media/cq_ultima_settimana_option b.27ce97a1.svg";